import React from "react";
import TextStyle from "../../../TextStyle";
import { AnimationTypingText } from "./AnimatingText";
import { Text as AnimatableText } from 'react-native-animatable';

const animatingSearchTextList = ["Medicines", "Surgical & Medical Items", "Wellness Products",]

class FadeTextList extends React.Component {
    state = { textList: animatingSearchTextList, index: 0 };
    render() {
        const { textList, index } = this.state;
        return (
            <AnimatableText key={index} iterationCount={1} direction="alternate"
                animation={'fadeIn'} duration={2000} onAnimationEnd={() => {
                    if (this.state.index < animatingSearchTextList.length - 1) this.setState({ index: this.state.index + 1 })
                    else this.setState({ index: 0 })
                }} style={[TextStyle.text16b]}>
                <AnimationTypingText text={textList[this.state.index % 4]} />
            </AnimatableText>
        );
    }
}

export default FadeTextList;